import { FC } from 'react';
import Layout from '@/components/layout/Layout';
import BookCardItem from '@/components/ui/book-card-item/BookCardItem';
import Pagination from '@/components/ui/pagination/Pagination';
import PageHeading from '@/components/ui/page-heading/PageHeading';
import Breadcrumbs from '@/components/ui/breadcrumbs/Breadcrumbs';
import { useGetUrlPath } from '@/hooks/useGetUrlPath';
import { BOOKS_FOR_PAGE } from '@/helpers/variables';
import CheckBoxFreeBook from '@/components/ui/checkbox-free-book/CheckBoxFreeBook';
import { IGenreBooksPage, IGenreBooksData } from '@/interfaces/genreBooksPage.interface';
import { IZhanr } from '@/interfaces/zhanr.interface';
import { getFirstLetterCaps } from '@/helpers/helpers';

import SectionTitleMenu from '@/components/ui/section-title-menu/SectionTitleMenu';

interface IGenreProps {
  books: IGenreBooksPage;
  genres: IZhanr;
  freeBooks?: boolean;
}

const Genre: FC<IGenreProps> = ({ books, genres, freeBooks }) => {
  const genreName = getFirstLetterCaps(genres.title);
  const genreAlias = genres.alias;
  const pagesCount = Math.ceil(books?.books.total_count / BOOKS_FOR_PAGE);

  //Seo block
  const SEO_TITLE = `${genreName} скачать книги бесплатно в fb2, epub, pdf или читать онлайн бесплатно.`;
  const SEO_DESCRIPTION = `${genreName} скачать книги бесплатно в fb2, epub, pdf или читать онлайн бесплатно в электронной библиотеке КучаКниг.`;
  const SEO_CANONICAL = `/zhanr/${genreAlias}/`;

  const getBookBreadcrumbs = () => {
    return {
      __html: `{
      "@context": "https://schema.org/",
      "@type": "BreadcrumbList",
      "itemListElement": [
        {"@type": "ListItem","position": 1,"name": "Главная","item": "https://kuchaknig.org/"},
        {"@type": "ListItem","position": 2,"name": "Жанры","item": "https://kuchaknig.org/zhanr/"},
        {"@type": "ListItem","position": 3,"name": "${genreName}","item": "https://kuchaknig.org/zhanr/${genreAlias}/"}
       ]
    }`,
    };
  };

  return (
    <Layout title={SEO_TITLE} description={SEO_DESCRIPTION} canonicalHref={SEO_CANONICAL} pageHref={useGetUrlPath()} sidebarSubGenres={genres.child}>
      <Breadcrumbs pageName="Жанры" pageAlias="/zhanr/" dynamicPageEmoji="📚 " dynamicPageName={`${genreName}`} />
      <script type="application/ld+json" dangerouslySetInnerHTML={getBookBreadcrumbs()} key="product-jsonld" />
      {/* {genres.child && genres.child.length > 0 && (
        <div className={styles.genreMenu}>
          {genres.child.map((genre: IZhanrChild) => (
            <div key={genre.id} className={styles.genreMenu__item}>
              <Link prefetch={false} className={styles.genreMenu__link} href={`/zhanr/${genre.alias}/`}>
                {genre.title}
              </Link>
            </div>
          ))}
        </div>
      )} */}
      <SectionTitleMenu>
        <PageHeading title={genreName} extraClassName="pageHeading_plain" />
        <CheckBoxFreeBook freeBooks={!!freeBooks} alias={`/zhanr/${genreAlias}`} />
      </SectionTitleMenu>
      <div data-cards="list" className="cardsWrapper">
        {books.books.data.length > 0 ? (
          books.books.data.map((book: IGenreBooksData) => <BookCardItem createdAt={book.created_at} alias={book.alias} author={book.author} book={book} rating={book.rating} key={book.id} draft={book.draft} readOnline />)
        ) : (
          <div>Нет книг</div>
        )}
      </div>
      <Pagination pagesCount={pagesCount ?? 0} postName={freeBooks ? `zhanr/${genreAlias}/?free_books=true&page=` : `zhanr/${genreAlias}/page=`} />
    </Layout>
  );
};

export default Genre;
